"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPieChartContainer = exports.StyledLegendData = exports.StyledLegendBackGround = exports.StyledLegend = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyledLegendBackGround = exports.StyledLegendBackGround = _styledComponents.default.div`
	${({
  background
}) => {
  return `
			background: ${background};
			width: 20px;
			height: 10px;
			margin-right: 5px;
		`;
}}
`;
const StyledLegendData = exports.StyledLegendData = _styledComponents.default.div`
	display: flex;
	padding: 5px 0px;
	align-items: center;
`;
const StyledLegend = exports.StyledLegend = _styledComponents.default.div`
	${({
  height
}) => {
  return `
			position: absolute;
			right: 0%;
			top: 0;
			max-height: ${height}px;
			overflow-x: auto;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: inherit;
		`;
}}
`;
const StyledPieChartContainer = exports.StyledPieChartContainer = _styledComponents.default.div`
	${({
  height,
  width
}) => {
  return `
            width: ${convertToProperValue(width)};
            height: ${convertToProperValue(height)};
        `;
}}
`;
const convertToProperValue = data => {
  if (!isNaN(Number(data))) return `${data}px`;
  return data;
};